export default {
    apiKey: 'AIzaSyDMRGGaX9INgvmxIhx2JeHTpaZoCHbz1zE',
    authDomain: 'community-map-dev.firebaseapp.com',
    databaseURL: 'https://community-map-dev.firebaseio.com',
    projectId: 'community-map-dev',
    storageBucket: 'community-map-dev.appspot.com',
    messagingSenderId: '170554440048',
    appId: '1:170554440048:web:13ea81228e0006347377b5',
    measurementId: 'G-VZC0GBYGTP',
};
//# sourceMappingURL=.fb-conf-dev.js.map